import {
    getNextItemsScopeItemKey,
    createItemCacheStore,
    IItemCacheStore,
    IItemsScopeInitializerPayload,
    IItemCacheDispatch,
    switchLayout,
    tilesLayoutType,
    openItem,
    Facet,
    readItems,
    IItemCache,
    resolveItems,
    invalidateItems,
    childItemsFacet,
} from '@ms/items-view';
import { filesAddon } from './filesAddon';
import { mailboxFileSetKeyFacet } from '../Schema/Facets';
import { getFilterString } from '../utils/getFilterString';
import { getParameterStore } from './ParametersStore';
import { itemsViewConfiguration } from '../logging/configuration';

export { IItemCacheStore };

export const itemCacheStore: IItemCacheStore = createItemCacheStore({
    configuration: itemsViewConfiguration,
});

interface ItemScopeKeyCacheItem {
    itemsScopeItemKey: string;
}

let itemKey: ItemScopeKeyCacheItem = {
    itemsScopeItemKey: getNextItemsScopeItemKey(),
};

const seenItemFacet = new Facet<boolean>('hasSeenItem');

export const updateItemsViewCache = () => {
    const filterStateString = getFilterString();

    const initializer = (payload: IItemsScopeInitializerPayload) => {
        return (dispatch: IItemCacheDispatch) => {
            dispatch(filesAddon);

            const hasSeenItem = dispatch(
                readItems((itemCache: IItemCache) =>
                    itemCache.demandItemFacet(seenItemFacet, payload.itemsScopeItemKey)
                )
            );

            if (!hasSeenItem) {
                dispatch(
                    switchLayout({
                        ...payload,
                        layoutType: tilesLayoutType,
                    })
                );
            }

            dispatch(
                resolveItems({ items: { [payload.itemsScopeItemKey]: seenItemFacet.pack(true) } })
            );

            const itemKey = mailboxFileSetKeyFacet.serialize({
                mailboxKey: { smtp: getParameterStore().mailboxInfo.deprecatedMailboxId },
                filterState: filterStateString,
            });

            dispatch(
                invalidateItems({
                    items: { [itemKey]: [childItemsFacet] },
                })
            );

            dispatch(
                openItem({
                    ...payload,
                    currentItemKey: itemKey,
                })
            );
        };
    };

    itemCacheStore.dispatch(
        initializer({
            itemsScopeItemKey: itemKey.itemsScopeItemKey,
        })
    );
};

export const getItemScopeItemKey = (): string | null => {
    return itemKey.itemsScopeItemKey || null;
};
